import React from 'react';
import { document } from 'ionicons/icons';
import { Case } from '../../../../services/buildfire/rdb/cases';
import { useDownloadReport } from '../../../../context/DownloadReportContext';
import ActionItem from '../ActionItem';

interface DownloadPDFProps {
  case: Case;
}

const DownloadPDF: React.FC<DownloadPDFProps> = ({ case: c }) => {
  const { downloadReport, isDownloading } = useDownloadReport();
  return (
    <ActionItem
      icon={document}
      disabled={isDownloading}
      onClick={() => downloadReport(c)}
      label="Download Report"
    />
  );
};

export default DownloadPDF;
